import { useResponsiveValue } from "../../styling";
import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, isNil, mergeProps, slot } from "../../shared";
import { Text } from "../../typography";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "span";

function useColor(color) {
  return useMemo(() => {
    if (!isNil(color)) {
      if (color.startsWith("rgb") || color.startsWith("hsl") || color.startsWith("#")) {
        return color;
      } else if (color.startsWith("--")) {
        return `var(${color})`;
      } else if (color.startsWith("alias")) {
        return `var(--o-ui-bg-${color})`;
      }

      return color;
    }
  }, [color]);
}

export function InnerDot(props) {
  const {
    as = DefaultElement,
    children,
    color,
    forwardedRef,
    ...rest
  } = props;
  const colorValue = useResponsiveValue(color);

  const labelMarkup = children && /*#__PURE__*/_jsx(Text, {
    children: children
  });

  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-dot", children && "has-label"),
      ref: forwardedRef,
      style: {
        ["--o-ui-dot-color"]: useColor(colorValue)
      }
    }),
    children: labelMarkup
  });
}
InnerDot.defaultElement = DefaultElement;
export const Dot = slot("dot", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerDot, { ...props,
  forwardedRef: ref
})));